import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class PlantypeService {

  constructor(private afdatabase: AngularFireDatabase) {}

  getTypePlan() {
    	return this.afdatabase.list('/plan_type');
  	}
}
